import * as React from "react"
import { ForwardedRef } from "react"

import { StyledSticky } from "./Styles"

interface StickyProps {
  children: React.ReactNode
  position: "top" | "bottom"
  $scrollableDivRef: React.RefObject<HTMLDivElement>
}

const Sticky = React.forwardRef(
  ({ children, position, $scrollableDivRef }: StickyProps, ref: ForwardedRef<HTMLDivElement>) => {
    const [isSticky, setIsSticky] = React.useState(false)
    const $stickyRef = React.useRef<HTMLDivElement>(null)
    React.useImperativeHandle(ref, () => $stickyRef.current!)

    React.useEffect(() => {
      const scrollableDiv = $scrollableDivRef.current!

      const handleScroll = () => {
        const { top, bottom } = $stickyRef.current!.getBoundingClientRect()
        const { innerHeight: screenHeight } = window
        const { scrollTop, scrollHeight } = scrollableDiv
        const isSticky =
          position === "top" ? top === 0 : bottom === screenHeight && scrollTop + screenHeight < scrollHeight
        setIsSticky(isSticky)
      }

      handleScroll()
      scrollableDiv.addEventListener("scroll", handleScroll)
      return () => scrollableDiv.removeEventListener("scroll", handleScroll)
    }, [position, $scrollableDivRef, $stickyRef])

    return (
      <StyledSticky ref={$stickyRef} position={position} isSticky={isSticky}>
        {children}
      </StyledSticky>
    )
  },
)

Sticky.displayName = "Sticky"

export default Sticky
